import React from 'react';
import {Button, Modal} from '@goproblems/ui';

import {hideModal, useSelector} from '@utils';
import {MODAL_RUSH_REFRESH} from '@utils';
import {useTranslation} from 'react-i18next';

export const RushRefreshModal = ({
    name = MODAL_RUSH_REFRESH,
}: {
    name?: string;
}) => {
    const show = useSelector(s => s.modalRushRefresh);
    const {t} = useTranslation();

    const handleClose = () => {
        hideModal(name);
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t('rush_refresh.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{t('rush_refresh.body')}</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => location.reload()}>
                    {t('common.refresh')}
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    {t('common.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
